import { KeyOutlined, SettingOutlined } from '@ant-design/icons';
import { RolePermissionManager, useSession } from '@zhiyue/core';
import { Alert, Menu, Modal, Spin } from 'antd';
import { BizAppConfig } from 'config/application.manifest';
import React, { useState } from 'react';
import { useOpenPlatformToken } from '@/hooks/useOpenPlatformToken';
import { hasOAuth2Session } from '@/services/oauth2';

type SettingsMenuKey = 'permissions';

const SETTINGS_MENU_ITEMS = [
  {
    key: 'permissions' as SettingsMenuKey,
    icon: <KeyOutlined />,
    label: '权限管理',
  },
];

const TRIGGER_MENU_ITEM = [
  {
    key: 'settings-trigger',
    icon: <SettingOutlined />,
    label: '设置',
  },
];

interface SettingsModalProps {
  collapsed?: boolean;
  /** 是否显示独立的“设置”触发菜单 */
  showTrigger?: boolean;
  /** 外部控制弹窗显示状态，不传时组件自管理 */
  open?: boolean;
  /** 外部控制关闭回调 */
  onClose?: () => void;
}

const SettingsModal: React.FC<SettingsModalProps> = ({
  collapsed,
  showTrigger = true,
  open: openProp,
  onClose,
}) => {
  const [innerOpen, setInnerOpen] = useState(false);
  const open = openProp !== undefined ? openProp : innerOpen;
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setInnerOpen(false);
    }
  };
  const [activeKey, setActiveKey] = useState<SettingsMenuKey>('permissions');
  const { currentUser, loading } = useSession();
  const { token, tokenError } = useOpenPlatformToken({
    enabled:
      open &&
      !loading &&
      Boolean(currentUser?.memberUuid) &&
      hasOAuth2Session(),
    refreshKey: currentUser?.memberUuid,
  });

  return (
    <>
      {showTrigger ? (
        <Menu
          mode="inline"
          inlineCollapsed={collapsed}
          selectable={false}
          items={TRIGGER_MENU_ITEM}
          onClick={() => setInnerOpen(true)}
          style={{ borderInlineEnd: 'none' }}
        />
      ) : null}
      <Modal
        title="系统设置"
        open={open}
        onCancel={handleClose}
        footer={null}
        width="90vw"
        styles={{
          body: {
            height: 'calc(90vh - 110px)',
            padding: 0,
            overflow: 'hidden',
          },
        }}
        style={{ top: 20 }}
        destroyOnClose
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: '100%',
            width: '100%',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: 180,
              flexShrink: 0,
              borderRight: '1px solid #f0f0f0',
              height: '100%',
              overflowY: 'auto',
              background: '#fff',
            }}
          >
            <Menu
              mode="inline"
              selectedKeys={[activeKey]}
              items={SETTINGS_MENU_ITEMS}
              onClick={({ key }) => setActiveKey(key as SettingsMenuKey)}
              style={{ height: '100%', borderRight: 'none' }}
            />
          </div>
          <div
            style={{ flex: 1, overflow: 'auto', minWidth: 0, height: '100%' }}
          >
            {activeKey === 'permissions' &&
              (tokenError ? (
                <Alert
                  type="error"
                  showIcon
                  message="开放平台 Token 获取失败"
                />
              ) : token ? (
                <RolePermissionManager
                  token={token}
                  namespace={BizAppConfig.appSsoClientId}
                />
              ) : (
                <Spin />
              ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SettingsModal;
